import { formatDate } from "shared/utils";
import { DateRange } from "widgets/booker/features/Steps/components/DatesAndGuests/useDatesAndGuests";

const SHORT_DATE = "MMM d";

export const getDatesSummaryString = (
  dateRange: DateRange,
  defaultString: string,
): string => {
  const startDate =
    dateRange.startDateISO.length > 0
      ? formatDate(dateRange.startDateISO, SHORT_DATE)
      : "";
  const endDate =
    dateRange.endDateISO.length > 0
      ? formatDate(dateRange.endDateISO, SHORT_DATE)
      : undefined;

  if (dateRange.startDateISO.length < 1) {
    return defaultString;
  }

  const endDateString = endDate ? ` - ${endDate}` : "";

  return startDate + endDateString;
};
